import { render, staticRenderFns } from "./settings-organization-order-attribution-one.vue?vue&type=template&id=67caaf07&scoped=true&"
import script from "./settings-organization-order-attribution-one.vue?vue&type=script&lang=js&"
export * from "./settings-organization-order-attribution-one.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67caaf07",
  null
  
)

export default component.exports